import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link } from "react-router-dom";
import Repo from "../../Utility/Repo";
import { useEffect, useState, useContext } from "react";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import ValidISEE from "../../Components/ValidISEE";
import ValidUser from "../../Components/ValidUser";
import LabelsLoader from "../../Utility/labelsLoader";

function HomeUser(props) {
  const apiToken = useContext(TokenContext);
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState({});
  const [announcementsBacheca, setAnnouncementsBacheca] = useState();

  const labels = LabelsLoader();

  useEffect(() => {
    // 👇️ set isMounted to true
    let isMounted = true;
    async function fetchData() {
      const result = await Promise.resolve(["Unmounted Component"]);

      // 👇️ only update state if component is mounted
      if (isMounted) {
        setLoading(false);

        Repo.getAnnouncementsBacheca(apiToken)
          .then((response) => {
            setAnnouncementsBacheca(response.data);
            setLoading(true);
          })
          .catch((error) => {
            console.log(error);
          });
        /*
        Repo.getUserServices(apiToken)
          .then((response) => {
            setServices(response.data);
            setLoading(true);
          })
          .catch((error) => {
            console.log(error);
            setLoading(true);
          });
          */
      }
    }

    fetchData();

    return () => {
      // 👇️ when component unmounts, set isMounted to false
      isMounted = false;
    };
  }, []);

  return (
    <>
      {announcementsBacheca && announcementsBacheca.length > 0 && (
        <div className="row mt-4 mb-4">
          <div className="col-lg-12">
            <h3 className="pl-2 mb-3">Bacheca</h3>
            <p className="pl-2">{labels.bandi_aperti}</p>
            <div className="row">
              {announcementsBacheca &&
                announcementsBacheca.length > 0 &&
                announcementsBacheca.slice(0, 3).map((x, index) => (
                  <div key={x.id} className="col-12 col-lg-4">
                    <a
                      href={`https://smartwelfare.comune.bari.it/istanze/lista_servizi/dettaglio_servizio/dettaglio_versione_servizio/iscrizioni?id=${x.externalId}`}
                      className="text-decoration-none"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="card-wrapper card-space cardCustom">
                        <div className="card card-bg no-after roundedCustomBandi p-2">
                          <div className="card-body">
                            <h5
                              style={{ fontSize: "23px" }}
                              className="card-title"
                            >
                              {x?.name}
                            </h5>

                            <p
                              style={{ fontSize: "20px" }}
                              className="card-text mb-0"
                            >
                              Data inserimento: <strong>{x?.dataInsert}</strong>
                            </p>

                            <div className="row">
                              <div className="col-12 mt-4 text-right">
                                {/* NON è un button */}
                                <div className="btn btn-outline-primary btn-sm d-inline-flex align-items-center">
                                  <span>Dettaglio</span>
                                  <svg className="icon icon-primary icon-sm ml-1">
                                    <use
                                      href={`${iconSprite}#it-arrow-right`}
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
      <h1>Servizi al cittadino</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p> {labels.elenco_servizi}</p>
      </div>
      <div className="row">
        <div className="col-12 col-lg-12 mb-3">
          <Link to="/profilo?scroll=true" className="text-decoration-none">
            <div className="card-wrapper card-space cardCustom">
              <div className="card card-bg no-after roundedCustom p-2">
                <div className="card-body d-flex align-items-start">
                  {/* ICONA A SINISTRA */}
                  <div className="me-3 flex-shrink-0">
                    <svg
                      className="icon icon-danger"
                      style={{ width: "3rem", height: "3rem" }}
                    >
                      <use href={`${iconSprite}#it-user`} />
                    </svg>
                  </div>

                  {/* TESTO A DESTRA */}
                  <div>
                    <h5 className="card-title mb-1">Profilo e pagamenti</h5>
                    <p className="card-text mb-0">
                      Accedendo a questa sezione potrai visualizzare gli ISEE
                      caricati in precedenza e aggiornare le informazioni
                      personali
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>

      {!loading && <Loader></Loader>}
    </>
  );
}

export default HomeUser;
